import {
  AZURE_UPLOAD_START,
  AZURE_UPLOAD_SUCCESS,
  AZURE_UPLOAD_ERROR,
} from "Constant";
import { downloadAzureFile, uploadAzureFile } from "Constant/apiConstant";
import { request } from "utils/request";
import { displayNotification } from "store/action";

const uploadAzureDataStart = () => {
  return { type: AZURE_UPLOAD_START };
};
const uploadAzureDataSuccess = (payload) => {
  return { type: AZURE_UPLOAD_SUCCESS, payload };
};
const uploadAzureDataError = (error) => {
  return { type: AZURE_UPLOAD_ERROR, error };
};

const uploadAzureData =
  (data, type, callback, extFileName, errorCB, setFile) =>
  (dispatch, getState) => {
    const headerOptions = {
      app_id: 4,
      "Content-Type": "multipart/form-data",
      //   Authorization:
      //     "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbHVzdGVyIjoiSU4wMDAxIiwiZ3VpZCI6IjY5N2Y5Njg3LWFkNTAtNDU1ZC1iZjliLWIxODc5YmZiMDhlYyIsIl9pZCI6IjYwYWY2MjcyM2VhZDc0MDAxMTFlMDhmMiIsImZOYW1lIjoiR2F1cmF2IFByYWphcGF0aSIsImxOYW1lIjoiIiwicHJvZmlsZUltYWdlIjoiIiwiaXNBY3RpdmUiOnRydWUsImlzUm9vdCI6ZmFsc2UsImlzUmVhZE9ubHkiOmZhbHNlLCJpYXQiOjE2MjIxMDY4MDgsImV4cCI6MTYyMjExNDAwOH0.cM6VEDAEjUUg6xAUnYAkbwdbqxqJwOlhZm48yd87hF4",
    };
    const payload = {
      containerName: data?.containerName || "rental",
      dirName: data?.dirName,
      resourceName: process.env.REACT_APP_AZURE_RESOURCE_NAME,
      file: data?.file,
    };
    const formData = new FormData();
    formData.append("containerName", payload?.containerName);
    formData.append("dirName", payload?.dirName);
    formData.append("resourceName", payload?.resourceName);
    let fileName = "";
    for (var i = 0; i < data?.file.length; i++) {
      // const temp_name = data?.file[i].name.split(".");
      const name = data?.file?.[i]?.name?.replaceAll(" ", "_");
      const temp_name = name?.split(".");
      const file_ext = temp_name[temp_name.length - 1];

      // const newName=name.replace("." + file_ext, "_") + new Date().getTime() + "." + file_ext;
      const timeStemp = new Date();
      const date =
        timeStemp.getDate() < 10
          ? "0" + timeStemp.getDate()
          : timeStemp.getDate();
      const month =
        timeStemp.getMonth() < 10
          ? "0" + (timeStemp.getMonth() + 1)
          : timeStemp.getMonth();
      const year = timeStemp.getFullYear();
      const hour =
        timeStemp.getHours() < 10
          ? "0" + timeStemp.getHours()
          : timeStemp.getHours();
      const minute =
        timeStemp.getMinutes() < 10
          ? "0" + timeStemp.getMinutes()
          : timeStemp.getMinutes();
      const second =
        timeStemp.getSeconds() < 10
          ? "0" + timeStemp.getSeconds()
          : timeStemp.getSeconds();
      const file_name = `${extFileName}-${`${year}${month}${date}${hour}${minute}${second}`}.${file_ext}`;
      // fileName = file_name;
      // const new_name= temp_name?.[0]?.replaceAll(" ","_")
      // const newName = (new_name ? (new_name + i + '_') : data?.file[i].name.replace("." + file_ext, "-")) + new Date().getTime() + "." + file_ext;
      formData.append("files", data?.file[i], file_name);
    }
    // formData.append("files", data?.file);
    const file = formData.get("files");
    dispatch(uploadAzureDataStart());
    try {
      request("POST", uploadAzureFile, formData, false, headerOptions)
        .then((res) => {
          if (!res?.error) {
            dispatch(uploadAzureDataSuccess(res?.data));
            callback && callback(res?.data, type, data?.rider_id, setFile);
            dispatch(
              displayNotification({
                open: true,
                message: "file uploaded successfully.",
                duration: 4000,
                severity: "success",
              })
            );
          } else {
            errorCB && errorCB();
            dispatch(uploadAzureDataError(res));
            dispatch(
              displayNotification({
                open: true,
                message: res?.errorMessage,
                duration: 4000,
                severity: "error",
              })
            );
          }
        })
        .catch((err) => {
          errorCB && errorCB();
          console.log("upload azure error", err);
          dispatch(uploadAzureDataError(err));
        });
    } catch (error) {
      errorCB && errorCB();
      dispatch(uploadAzureDataError("Something went wrong"));
    }
  };

export { uploadAzureData };